// 登陆态key
export const ACCESS_TOKEN = 'quan_access_token';
// 缓存账号key
export const CACHED_ACCOUNTS_KEY = 'quan_cached_accounts';
// 国家/手机号数据
export const CACHED_COUNTRIES_KEY = 'quan_cached_countries';
// 选中的币种
export const SELECTED_BALANCE_KEY = 'quan_selected_balance';
// ip信息
export const IP_LOCATION_KEY = 'quan_ip_location';
// 归因的uuid
export const SHARE_UUID_KEY = 'quan_share_uuid';
// 登录完成后要重定向地址（H5跳转app在app端完成登录后用到）
export const REDIRECT_URL_KEY = 'quan_redirect_url';
// utm_act, 归因参数key
export const UTM_ACT_KEY = 'quan_utm_act';
// 用户归因活动来源attributeAct
export const ATTRIBUTE_ACT_KEY = 'quan_attribute_act';
// seo_channel 来源缓存
export const SEO_CHANNEL_ORIGIN_KEY = 'seo_channel_origin';
// seo apk download url 
export const SEO_APK_DOWNLOAD_URL_KEY = 'seo_apk_download_url';
// pwa 记录是否已经自动定位
export const PWA_AUTO_LOCATION_KEY = 'quan_pwa_auto_jump';
// 游客登录是否退出
export const GUEST_AUTO_LOGIN_OUT = 'quan_guest_auto_login_out';
// 背包上次选中的 tab
export const BACKPACK_ACTIVE_TAB_KEY = 'quan_backpack_active_tab';
